import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import {t} from 'i18next';
import {useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import {
  requestMediatedToken,
  userInfo as userInfoService,
} from '../../../api/Authentication';
import {clearAskLioState} from '../../../redux/slices/askLioSlice';
import {setUser, UserInfoType} from '../../../redux/slices/userSlice';
import {setAuthToken} from '../../../utils/auth';
import {AuthPageLayout, redirectAfterCallback} from './shared';
// import { useAuthorizationService } from '../../../api/authorization';
import {logout as logoutService} from '../../../api/Authentication';
import {getFeatureSettings} from '../../../api/UserManagementService';
import {loginAction} from '../../../redux/rootAction';
import {setFeatureSettings} from '../../../redux/slices/featureSettingsSlice';
import {ERROR_STATUS_CODE} from '../../../constants/constants';
import {leaveAppIfPlatformMaintenance} from '../../../utils/maintenanceLeaveApp';

const parseUserInfoType = (userInfoResponse: any) => {
  const userDto = userInfoResponse.data.user;

  const user: UserInfoType = {
    givenname: userDto.firstName,
    surname: userDto.lastName,
    email: userDto.email,
    name: `${userDto.firstName} ${userDto.lastName}`,
    age: 0,
    userId: userDto.userId,
    userKind: userDto.userKind,
    status: userDto.status,
  };

  return user;
};

export const Callback = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [userKind, setUserkind] = useState<number | null>(null);

  // const authorizationService = useAuthorizationService();

  useEffect(() => {
    dispatch(clearAskLioState());

    const auroraIsUnavailable = (error: any) => {
      const statusCode = error?.response?.status;
      const badGateway = statusCode === ERROR_STATUS_CODE.STATUS_502;
      const serviceUnavailable = statusCode === ERROR_STATUS_CODE.STATUS_503;
      return badGateway || serviceUnavailable;
    };

    const getToken = async () => {
      try {
        const tokens = await requestMediatedToken();
        setAuthToken(tokens.accessToken);
      } catch (error: any) {
        console.error(error);
        if (auroraIsUnavailable(error)) {
          throw error;
        }
      }
    };

    const getUserInfo = async () => {
      try {
        const userInfo = await userInfoService();
        const user = parseUserInfoType(userInfo);
        if (user.status.toLowerCase() !== 'active') {
          await logoutService(dispatch); // clear session + redux
          navigate('/login?error=email_inactive'); // redirect to login page
          return;
        }

        setUserkind(user.userKind);
        dispatch(setUser(user));
      } catch (error: any) {
        console.error(error);
        if (auroraIsUnavailable(error)) {
          throw error;
        }
      }
    };

    const getAppFeatureSettings = async () => {
      try {
        const featureSettings = await getFeatureSettings();
        dispatch(setFeatureSettings(featureSettings?.data?.data ?? []));
      } catch (error: any) {
        console.error(error);
        if (auroraIsUnavailable(error)) {
          throw error;
        }
      }
    };

    const initAuth = async () => {
      try {
        await Promise.all([getToken(), getUserInfo(), getAppFeatureSettings()]);
        dispatch(loginAction());
      } catch (error: any) {
        if (auroraIsUnavailable(error)) {
          await leaveAppIfPlatformMaintenance(dispatch);
          return;
        }
        throw error;
      }
    };

    initAuth();
  }, []);

  useEffect(() => {
    if (userKind !== null) {
      redirectAfterCallback(navigate, userKind);
    }
  }, [userKind, navigate]);

  return (
    <AuthPageLayout>
      <Box className="login-form">
        <div className="login-content">
          <Typography className="typo-text headline2_size mist-color">
            {t('auth.login.callbackMsg1')}
            <br />
            {t('auth.login.callbackMsg2')}
          </Typography>
        </div>
      </Box>
    </AuthPageLayout>
  );
};
